<app-modal [activeModal]="activeModal" [isReadonly]="true" [title]="title">
  <dl>
    <div *ngIf="recordData.autorNazwa" class="mb-4">
      <dt i18n>Autor wpisu</dt>
      <dd>{{ recordData.autorNazwa }}</dd>
    </div>
    <div *ngIf="recordData.dataDodania" class="mb-4">
      <dt i18n>Data utworzenia</dt>
      <dd>{{ recordData.dataDodania | date }}</dd>
    </div>
    <div *ngIf="recordData.autorModyfikacjiNazwa" class="mb-4">
      <dt i18n>Autor modyfikacji wpisu</dt>
      <dd>{{ recordData.autorModyfikacjiNazwa }}</dd>
    </div>
    <div *ngIf="recordData.dataModyfikacji" class="mb-4">
      <dt i18n>Data modyfikacji wpisu</dt>
      <dd>{{ recordData.dataModyfikacji | date }}</dd>
    </div>
    <div *ngIf="recordData.liczbaModyfikacji" class="mb-4">
      <dt i18n>Liczba modyfikacji wpisu</dt>
      <dd>{{ recordData.liczbaModyfikacji }}</dd>
    </div>
  </dl>
</app-modal>
